import React from 'react'
import './Footer.css'

import { Route, Switch } from 'react-router-dom'
import { translate } from 'react-i18next'

import { arrF, CopyrightSvg, InstSvg, FaceSvg } from './SVGarr'
import LinkFooter from './LinkFooter'
import LinkFooterBlock from './LinkFooterBlock'
import ButtonOrder from './ButtonOrder'


const Footer = (props) => {
  return(
    <footer>
      <div className="ftop">
        <div className="ftextTop"> {props.t('footerH1')} </div>
        <ButtonOrder />
      </div>
      <div className="wrapFooter">
      <Switch>
        <Route path="/home/:block" render={(props) => (<LinkFooterBlock items={arrF} {...props} />)} />
        <Route path="/" render={(props) => (<LinkFooter items={arrF} {...props} />)} />
      </Switch>
      </div>
      <div className="footerBottom">
        <a href="https://www.instagram.com/vazonstudia/" target="_blank" rel="noopener noreferrer"> {InstSvg} </a> 
        <a href="https://www.facebook.com/vazonstudia/" target="_blank" rel="noopener noreferrer"> {FaceSvg} </a>
        <div className="footerCont">
          Контакти
          <div>
            +38 097 469 06 28 <br/> 
            +38 066 313 81 05 <br/>         
            Telegram Viber <br/>
            vazon@gmail.com
          </div>
        </div>
      </div>
      <a className="copyright" href="https://www.salt.com.ua" title="Web-Studio Salt"  target="_blank" rel="noopener noreferrer">
        {CopyrightSvg} _Salt 
      </a>
    </footer>
  )
}

export default translate('translations')(Footer)


// WEBPACK FOOTER //
// ./src/components/Footer.jsx